/**
 * Get uniba servizi online action
 * @module src/actions/getUnibaServiziOnline
 */
export const GET_UNIBA_SERVIZIONLINE = 'GET_UNIBA_SERVIZIONLINE';

/**
 * Get uniba servizi online.
 * @function getUnibaServiziOnline
 * @returns {Object} Get uniba servizi online action.
 */
export function getUnibaServiziOnline(params) {
  return {
    type: GET_UNIBA_SERVIZIONLINE,
    request: {
      op: 'get',
      path: `/@getServiziOnline`,
      params: params,
    },
  };
}
